/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './actiontypes';

const axiosPayLoad = {
  errorMessagesInRedux: [],
  updateGeneralParamObj: {},
  saveOrUpdateMessage: '',
  generalSystemParameter: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ERROR_MESSAGE_UPG:
      return {
        ...state,
        errorMessagesInRedux: action.errorMessagesInRedux,
      };
    case actionTypes.UPDATE_PARAM_GENERAL_SCREEN_TAB_DATA:
      return {
        ...state,
        updateGeneralParamObj: action.updateGeneralParamObj,
      };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER_UPG:
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    case actionTypes.SAVE_OR_UPDATE_UPG:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    default:
      return state;
  }
};

export default reducer;
